// Note: these must match translation keys marketplace-ui-reviews.responses
export const TITLE = 'title';
export const REVIEW = 'text';
export const FOR = 'for';
export const PROS = 'pros';
export const CONS = 'cons';
export const CUSTOMIZABLE = 'customizable'; // Asset marketplace only
export const SERVICES = 'catalogServices'; // Solutions marketplace only
export const PRIVATE = 'private';
export const QuestionOrder = [TITLE, REVIEW, FOR, CUSTOMIZABLE, PROS, CONS, SERVICES];